import React from "react"

class UserEdit extends React.Component {
  render() {
    return <div>USER EDIT</div>
  }
}

export default UserEdit



// WEBPACK FOOTER //
// ./src/scenes/User/UserEdit/index.js